import React from 'react';
import './MapeamentoDetails.css';
import MapeamentoProdutos from './MapeamentoProdutos';

const MapeamentoDetails = ({ mapeamento, onBack, onRefresh }) => {
  if (!mapeamento) {
    return (
      <div className="no-data">
        <div className="no-data-icon">📋</div>
        <p>Nenhum mapeamento selecionado</p>
        <span>Selecione um mapeamento na lista ao lado para visualizar os detalhes</span>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    const statusConfig = {
      'pending': { label: 'Pendente', className: 'status-pending' },
      'processing': { label: 'Processando', className: 'status-processing' },
      'success': { label: 'Sucesso', className: 'status-success' },
      'partial_success': { label: 'Sucesso Parcial', className: 'status-partial' },
      'error': { label: 'Erro', className: 'status-error' }
    };

    const config = statusConfig[status] || { label: status, className: 'status-unknown' };
    return <span className={`status-badge ${config.className}`}>{config.label}</span>;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="mapeamento-details">
      <div className="details-header">
        <div className="details-header-left">
          {onBack && (
            <button className="btn-back-details" onClick={onBack}>
              ← Voltar
            </button>
          )}
          <h3>Detalhes do Mapeamento</h3>
        </div>
        <div className="details-status">
          {getStatusBadge(mapeamento.status)}
        </div>
      </div>

      <div className="details-content">
        <div className="details-section">
          <h4>Informações Gerais</h4>
          <div className="details-grid">
            <div className="detail-item">
              <span className="detail-label">ID:</span>
              <span className="detail-value">{mapeamento.id}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Empresa:</span>
              <span className="detail-value">{mapeamento.tenantId}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Nota de Entrada:</span>
              <span className="detail-value">#{mapeamento.idNotaEntrada}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Status:</span>
              <span className="detail-value">{getStatusBadge(mapeamento.status)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Criado em:</span>
              <span className="detail-value">{formatDate(mapeamento.createdAt)}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Atualizado em:</span>
              <span className="detail-value">{formatDate(mapeamento.updatedAt)}</span>
            </div>
          </div>
        </div>

        {mapeamento.errorMessage && (
          <div className="details-section">
            <h4>Mensagem de Erro</h4>
            <div className="error-box">
              {mapeamento.errorMessage}
            </div>
          </div>
        )}

        <div className="details-section">
          <h4>Produtos do Mapeamento</h4>
          <MapeamentoProdutos
            mapeamentoJson={mapeamento.mapeamentoJson}
            tenantId={String(mapeamento.tenantId)}
            idCliente={mapeamento.mapeamentoJson && (typeof mapeamento.mapeamentoJson === 'string' ? (() => { try { return JSON.parse(mapeamento.mapeamentoJson).id_cliente; } catch { return undefined; } })() : mapeamento.mapeamentoJson.id_cliente)}
            idNotaEntrada={mapeamento.idNotaEntrada}
            onRefresh={onRefresh}
          />
        </div>
      </div>
    </div>
  );
};

export default MapeamentoDetails;
